export const endpoints = {
    mock: 'http://localhost:3000',
    rest: 'https://api.tool.markables.net/api',
};
